<template>
<div class="chapter">
<div class="inner_page">
<p class="copy-3"><span class="bold">Suppliers</span></p>
<p class="copy">If you have difficulty in obtaining any of the materials</p>
<p class="copy">and equipment mentioned in this book, please visit</p>
<p class="copy">the Search Press website for details of suppliers:</p>
<p class="copy"><span class="weblink"><a href="http://www.searchpress.com" target="_blank"><span class="underline">www.searchpress.com</span></a></span></p>
<p class="copy-3"><span class="bold">Publishers’ note</span></p>
<p class="copy">All the step-by-step photographs in this book feature</p>
<p class="copy">the author, Geoff Kersey, demonstrating how to paint</p>
<p class="copy">in watercolour. No models have been used.</p>
<p class="copy-2-t"><a href="#/xhtml/02_Halftitle#page_1">Page 1</a></p>
<p class="copy-22"><span class="bold">Boatyard at Woodbridge</span></p>
<p class="copy-2a">340 x 270mm (13½ x 10½in)</p>
<p class="copy-2a">Here the positioning of the boats leads the eye to the</p>
<p class="copy-2a">distant area just to the right of the whitewashed building.</p>
<p class="copy-2a">Note that the planks of timber at the bottom right plus the</p>
<p class="copy-2a">suggested lines on the yard also point to this area. There is</p>
<p class="copy-2a">no mistaking where we are meant to look in this scene.</p>
<p class="copy-2-t"><a href="#/xhtml/03_Dedication#page_2">Pages 2–3</a></p>
<p class="copy-22"><span class="bold">Dunwich Beach</span></p>
<p class="copy-2a">610 x 394mm (24 x 15½in)</p>
<p class="copy-2a">I love to paint this type of scene, so typical of the Norfolk</p>
<p class="copy-2a">and Suffolk coasts, where the landscape is dominated by</p>
<p class="copy-2a">huge skies. Note how a second glaze was used after the</p>
<p class="copy-2a">first one had dried, leaving a small area in the top third</p>
<p class="copy-2a">where the viewer glimpses a patch of light. The small</p>
<p class="copy-2a">cliffs, old hut and beached boats lend just enough interest</p>
<p class="copy-2a">without making the scene too cluttered.</p>
<p class="copy-2-t"><a href="#/xhtml/07_Introduction#page_7">Opposite</a></p>
<p class="copy-22"><span class="bold">Bluebell Wood</span></p>
<p class="copy-2a">305 x 446mm (12 x 18in)</p>
<p class="copy-2a">Unusually for me, this scene has not even a glimpse of sky</p>
<p class="copy-2a">– instead the mass of greenery encourages the viewer to</p>
<p class="copy-2a">focus on the carpet of bluebells, created using a mixture</p>
<p class="copy-2a">of cobalt blue and cobalt violet. Note how the positioning</p>
<p class="copy-2a">of the trees uses linear perspective to lead the viewer into</p>
<p class="copy-2a">the painting.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Suppliers.vue?36ac8382